import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as Description16 } from 'assets/svgs/description.svg';
import { PanelHeaderTitle } from 'components/atoms/collapse';
import { IconShell } from 'components/atoms/icon-shell';

export const TaskDescriptionTitle: FC = () => (
  <PanelHeaderTitle
    icon={<IconShell icon={<Description16 />} />}
    title={
      <span data-cy="task_description.title">
        <FormattedMessage id="description" />
      </span>
    }
  />
);
